import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { bootstrapAppAccess, clearNotifications, hideNotificationItem } from '../../actions/app-actions';

import App from './app';

const mapStateToProps = ({ appReducer }) => ({
    appReducer,
    messages: appReducer.messages,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            clearNotifications,
            hideNotificationItem,
            bootstrapAppAccess,
        },
        dispatch,
    );

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);

export default AppContainer;
